export default __webpack_public_path__ + "static/media/yelpcamp.c49fd943.JPG";